import styled from "styled-components";
import { BREAKPOINTS, desktop, mobile } from "../../variables/Breakpoints";
import { setFlex, setPosition } from "../../variables/Position";
import { COLOURS } from "../../variables/Colors";

export const Wrapper = styled.div`
  ${setPosition({ position: "relative" })};
  ${props =>
    props.$flex &&
    `
  ${setFlex({ direction: "row" })}
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setFlex({ direction: "column" })}
  }
  `};
  ${props => props.$mobile && mobile};
`;

export const StackedWrapper = styled(Wrapper)`
  ${props => setFlex({ direction: props.$direction })};
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setFlex({ align: "flex-start", direction: "column" })};
  }
`;

export const ImageContainer = styled.div`
  ${setFlex({ align: "center", direction: "column" })};
  width: 100%;
  height: ${props => (props.$balance ? "auto" : "100%")};
  ${props =>
    props.$margin &&
    `
    @media (max-width: ${BREAKPOINTS.md}px) {
      margin-top: 2.5rem;
    }
  `};
  ${props =>
    props.$split &&
    `
    margin: 0 0.5rem;
    @media (max-width: ${BREAKPOINTS.md}px) {
      margin: 0 0 2rem 0;
    }
  `};
`;

export const Image = styled.img`
  width: 100%;
  max-width: ${props => (props.$split ? "50vw" : "100%")};
  height: auto;
  @media (max-width: ${BREAKPOINTS.md}px) {
    max-width: 100%;
  }
  ${props => props.$desktop && desktop};
  ${props => props.$mobile && mobile};
  ${props =>
    props.$quote &&
    `
  width: auto;
  height: 100%;
  `};
`;

export const ImageCredits = styled.div`
  ${props =>
    setFlex({
      justify: props.$justify || "center",
      align: props.$align || "center",
    })};
  ${props =>
    props.$padding &&
    `
    padding: 2rem;
    @media (max-width: ${BREAKPOINTS.md}px) {
      padding: 1rem;
    }
    @media (max-width: ${BREAKPOINTS.sm}px) {
      padding: 0.8rem;
    }
    @media (max-width: ${BREAKPOINTS.xs}px) {
      padding: 0 0.4rem 0.4rem 0.4rem;
    }
  `};
  @media (max-width: ${BREAKPOINTS.md}px) {
    width: 100%;
  }
  ${props =>
    props.$title &&
    `
    min-width: 25%;
    @media (max-width: ${BREAKPOINTS.md}px) {
      min-width: 15%;
    }
    @media (max-width: ${BREAKPOINTS.sm}px) {
      width: auto;
      min-width: unset;
      margin-left: 0.5rem;
    }
  `};
  margin-top: 0.25rem;
  @media (max-width: ${BREAKPOINTS.md}px) {
    margin: ${props => (props.$heading ? "0.5rem 0" : "0.5rem")};
  }
`;

export const ImageCreditsContainer = styled.div`
  ${props => props.$flex && setFlex({})};
  ${props =>
    props.$balance &&
    `
      flex-grow: 1;
      ${setFlex({ align: "flex-end" })};
      padding-bottom: 1.5rem;
      @media (max-width: ${BREAKPOINTS.md}px) {
        padding-bottom: 0;
      }
  `};
  width: ${props => (props.$widthSize ? "80%" : "100%")};
  @media (max-width: ${BREAKPOINTS.md}px) {
    width: 100%;
  }
`;

export const SmallHeading = styled.h4`
  font-family: "univers-lt-roman";
  font-size: 0.8rem;
  line-height: 1rem;
  color: ${COLOURS.primary.pink};
  font-weight: ${props => (props.$bold ? "bold" : "normal")};
  margin: 0;
  ${props =>
    props.$indent &&
    `
    text-indent: 3em;
    @media (max-width: ${BREAKPOINTS.sm}px) {
      text-indent: 0;
    }
  `};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    font-size: 0.6rem;
    line-height: 0.7rem;
  }
`;

export const CreditsContainer = styled.div`
  ${props => setFlex({ justify: props.$justify, align: "flex-end" })};
  min-width: 45%;
  @media (max-width: ${BREAKPOINTS.md}px) {
    margin: 0.5rem;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ justify: "center", align: "center" })};
    min-width: unset;
  }
`;

export const QuoteContainer = styled.div`
  ${setFlex({ justify: "center", align: "center" })};
`;
